import React, { useEffect } from 'react'
import { TextStyle, ViewStyle } from 'react-native'
import { useHistory } from 'react-router'
import { setPageTitle } from '@trivie/core'
import { observer } from 'mobx-react-lite'
import { Button, color, Text } from '@trivie/ui-mobile'
import { ReactComponent as AppStore } from './app-store.svg'
import PlayStore from './play-store.png'
import pmb from './images/pmb.png'

export const LoginScreen = observer(() => {
  const history = useHistory()

  useEffect(() => {
    setPageTitle(`Login - ${process.env.REACT_APP_SITE_TITLE}`)
  }, [])

  const goToMagicLink = () => {
    history.push('/login/magic')
  }

  const getDeviceDownloadBadges = () => {
    // @ts-ignore
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    // @ts-ignore
    if (/android/i.test(userAgent)) {
      return (
        <a
          style={{ width: 165 }}
          href="https://play.google.com/store/apps/details?id=com.trivie.engage.pmb"
        >
          <img width="100%" height="100%" src={PlayStore} />
        </a>
      )
    }

    // @ts-ignore
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return (
        <a href="https://apps.apple.com/us/app/prometric-boost/id1671826889">
          <AppStore width={165} height={49.05} />
        </a>
      )
    }

    return (
      <div style={{ flexDirection: 'row', justifyContent: 'center' }}>
        <a
          style={{ marginRight: 12, left: -5, position: 'relative' }}
          href="https://apps.apple.com/us/app/prometric-boost/id1671826889"
        >
          <AppStore width={165} height={49.05} />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.trivie.engage.pmb">
          <img style={{ width: 165 }} src={PlayStore} />
        </a>
      </div>
    )
  }

  return (
    <div style={ROOT}>
      <div style={CONTAINER}>
        <div style={CONTENT}>
          <img style={{ rotate: '-13deg', width: 110, height: 68 }} src={pmb} />
          <Text variant="titleEmphasized" style={BRANDING_TEXT} text="Prometric Boost" />
          <Text
            variant="titleMedium"
            style={TAGLINE}
            text="Boost your learning and prepare for your Prometric-proctored exams with quizzes, adaptive reinforcement quizzes, and more."
          />
          <Button
            accessibilityRole="link"
            accessibilityLabel="Go to Magic Link"
            style={SUBMIT}
            tx="Onboarding.Login.logIn"
            onPress={goToMagicLink}
          />
          {getDeviceDownloadBadges()}
        </div>
      </div>
    </div>
  )
})

const BRANDING_TEXT: TextStyle = {
  fontSize: 40,
  marginBottom: 8,
}
const ROOT: React.CSSProperties = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  justifyContent: 'center',
}
const CONTAINER: React.CSSProperties = {
  flexDirection: 'row',
  flex: 1,
  display: 'flex',
  maxHeight: 576,
  justifyContent: 'center',
  width: '33%',
  minWidth: 375,
  alignSelf: 'center',
}
const CONTENT: React.CSSProperties = {
  height: '100%',
  flex: 1,
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignSelf: 'center',
}
const TAGLINE: TextStyle = {
  textAlign: 'center',
  color: color.shade70,
  marginBottom: 6,
  marginHorizontal: 28,
}

const SUBMIT: ViewStyle = {
  marginHorizontal: 20,
  width: 335,
  alignSelf: 'center',
}
